import React from "react";
import style from "./Popup.module.css";

function Popup(props) {
  return (
    <div className={`${!props.down ? style.popupTop : style.popupDown}`}>
      <p className={style.title}>{props.title}</p>
      <p className={style.text}>{props.text}</p>
      {!props.down ? <span className={style.arrowDown}></span> : null}
      {props.down ? <span className={style.arrowUp}></span> : null}
    </div>
  );
}

export default Popup;
